import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/* Rôles autorisés à ouvrir le back-office.
   Cette liste reproduit `ROLES_BACK_OFFICE` du serveur
   (API/Diagnostic_data/diagnostic_API/permissions.py). C'est une commodité
   d'affichage, pas une protection : le serveur refuse de lui-même toute
   requête d'un rôle non autorisé. Sans ce garde, un dirigeant d'association
   qui se connecte ici traversait la console — vide, mais visible. */
const ROLES_BACK_OFFICE = ['SUPER_ADMIN', 'ADMIN', 'ANALYSTE', 'COACH'];

export default function PrivateAdminRoute({ children, user }) {
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user.is_active === false) {
    return <Navigate to="/login" replace />;
  }

  if (user.first_login) {
    return <Navigate to="/complete-profile" replace />;
  }

  if (!ROLES_BACK_OFFICE.includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--bg-main)]">
        <div className="max-w-md text-center">
          <h1 className="titre-page mb-2">
            Cet espace n'est pas le vôtre
          </h1>
          <p className="text-sm text-[var(--text-muted)] leading-relaxed mb-6">
            La console d'administration est réservée à l'équipe ASSO-PRO.
            Votre espace personnel se trouve sur le site principal.
          </p>
          <a
            href="https://assopro.impactlab-cilis.org/"
            className="inline-flex items-center justify-center px-5 min-h-[44px] rounded-pastille bg-[#1b1a65] text-white text-sm font-semibold"
          >
            Aller à mon espace
          </a>
        </div>
      </div>
    );
  }

  return children;
}
